import React, { useState } from 'react'
import ChatUserList from '../../components/chat/ChatUserList'
import ChatRoom from '../../components/chat/ChatRoom'
import { useUserStore } from '../../store/userStore'

const ChatPage = () => {
    const { userInfo } = useUserStore(state => state)

    const [roomId, setRoomId] = useState('') // 채팅방 id
    const [receiverInfo, setReceiverInfo] = useState('')


    return (
        <div>
            <div className='d-flex' style={{ border: "1px solid #ddd" }}>
                <div>
                    {!roomId && <ChatUserList setRoomId={setRoomId} myInfo={userInfo} setOtherInfo={setReceiverInfo} />}
                </div>

                {
                    roomId
                        ? <ChatRoom roomId={roomId} setRoomId={setRoomId} senderInfo={userInfo} receiverInfo={receiverInfo} />
                        : <div className='d-flex w-100 justify-content-center align-items-center'>채팅방을 선택해주세요.</div>
                }
            </div>

        </div>
    )
}

export default ChatPage